var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pagination-wrap"},[_c('a-pagination',{attrs:{"total":_vm.total,"defaultPageSize":10,"defaultCurrent":1},on:{"change":_vm.onChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }